export const API_PATH = '/api';
export const TOKEN = 'FF_TOKEN';